export default {"src":"/_next/static/media/phone_24.88758f03.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};